import { FC, lazy } from 'react';
import { Navigate, Route, useLocation } from 'react-router';
import { VideoManagerProvider } from './context/VideoManagerProvider';
import { useVideoManagerContext } from './context/VideoManagerContext';

const LazyVideoManagerModalPage = lazy(() =>
  import('./VideoManagerModalPage').then(({ VideoManagerModalPage }) => ({ default: VideoManagerModalPage })),
);
const LazyAddVideoPage = lazy(() =>
  import('./components/AddVideo/AddVideoPage').then(({ AddVideoPage }) => ({ default: AddVideoPage })),
);
const LazyLibraryPage = lazy(() =>
  import('./components/Library/VideoLibraryPage').then(({ VideoLibraryPage }) => ({ default: VideoLibraryPage })),
);

const LazyAnimateImagePage = lazy(() =>
  import('./components/AddVideo/AnimateImage').then(({ AnimateImage }) => ({ default: AnimateImage })),
);
const LazyGenerateVideoPage = lazy(() =>
  import('./components/AddVideo/GenerateVideo').then(({ GenerateVideo }) => ({ default: GenerateVideo })),
);

const RedirectToAdd: FC = () => {
  const { state } = useVideoManagerContext();
  const { search } = useLocation();
  return <Navigate to={{ pathname: 'add', search }} replace state={state} />; // keeps the background page
};

// This is a plain constant holding <Route> elements, not a component,
// so it can be dropped into any <Routes>.
export const videoManagerRoute = (
  <Route
    path="/video-manager/:advertiserPrettyId"
    element={
      <VideoManagerProvider>
        <LazyVideoManagerModalPage />
      </VideoManagerProvider>
    }
  >
    <Route index element={<RedirectToAdd />} />
    <Route path="add" element={<LazyAddVideoPage />} />
    <Route path="add/animate" element={<LazyAnimateImagePage />} />
    <Route path="add/generate" element={<LazyGenerateVideoPage />} />
    <Route path="library" element={<LazyLibraryPage />} />
    <Route path="library/:videoId" element={<LazyLibraryPage />} />
  </Route>
);
